import './RelatedTag.scss';
import { Tag } from 'antd';
import { usePeriscopeActions } from '../../hooks';
import React, { useCallback } from 'react';
export const RelatedTag = ({ displayName, sonarObjectId, sonarObjectType }) => {
    const { openPeriscope } = usePeriscopeActions();
    const hasSonarObjectId = Number.isInteger(sonarObjectId);
    const handleTagClick = useCallback((e) => {
        e.stopPropagation();
        if (hasSonarObjectId && sonarObjectType) {
            openPeriscope({
                id: sonarObjectId,
                name: displayName,
                openedFromIndex: -1,
                type: sonarObjectType
            });
        }
    }, [displayName, hasSonarObjectId, openPeriscope, sonarObjectId, sonarObjectType]);
    const onClick = hasSonarObjectId ? handleTagClick : undefined;
    return (React.createElement("div", { className: 'related-tag salesforce' },
        React.createElement(Tag, { onClick: onClick }, displayName)));
};
